export default {
  name: 'api', // api 名稱
  endLoadingDelay: 0, // 延遲loading結束時間
  errorHandle: true, // 執行錯誤處理（顯示message, 登出判斷, reject）
  showMessage: true, // 顯示message
  logoutRedirect: true, // 登出轉址判斷
}
